import casex from 'casex'

function usePrefix(prefix: string, delimiter: string = '-') {
  const delimitedPrefix = casex(prefix, 'ca' + delimiter + 'se')

  function p(value?: any) {
    if (!value) return delimitedPrefix
    return `${delimitedPrefix}${delimiter}${value.toString()}`
  }

  return p
}

export default usePrefix
